import React, { useEffect, useState } from "react"
import { Table, Col, Row } from "reactstrap"
import api from "API/Api"
import { Link } from "react-router-dom"
import SweetAlert from "react-bootstrap-sweetalert"
import loader from "./../../assets/loading/loader.gif"
import { usePermissions } from "API/PermissionContext"

const Designations = props => {
  const { canAdd, canEdit, canDelete, MODULE } = usePermissions()
  const MID = MODULE.CONFIGURATIONS
  const [designations, setDesignations] = useState([])
  const [desigId, setDesigId] = useState("")
  const [cell, setCell] = useState("")
  const [confirm_alert, setconfirm_alert] = useState(false)
  const [success_dlg, setsuccess_dlg] = useState(false)
  const [dynamic_title, setdynamic_title] = useState("")
  const [dynamic_description, setdynamic_description] = useState("")
  const [search, setSearch] = useState({desingtype:''})
  const [checkedItems, setCheckedItems] = useState(new Array(designations.length).fill(false))
  const [parentChecked, setParentChecked] = useState(false)
  const [load, setLoad] = useState(false)
  const [confirm_multiple_alert, setconfirm_multiple_alert] = useState(false)
  const [showFilter, setShowFilter] = useState(false)

  useEffect(() => { fetchData() }, [load])

  const fetchData = async () => {
    const response = await api.get("designations")
    setDesignations(Array.isArray(response.data.data) ? response.data.data : response.data.data?.data || [])
  }
  const fetchDelete = async () => {
    const delteDesig = await api.delete("delete-designation/" + desigId)
    if (delteDesig.data.success === true) setLoad(!load)
  }
  const handleCheckboxChange = (i) => {
    const newCheckedItems = [...checkedItems]
    newCheckedItems[i] = !newCheckedItems[i]
    setCheckedItems(newCheckedItems)
    setParentChecked(newCheckedItems.every((item) => item))
  }
  const handleParentCheckboxChange = () => {
    const newParentChecked = !parentChecked
    setParentChecked(newParentChecked)
    setCheckedItems(new Array(designations.length).fill(newParentChecked))
  }
  const getSelectedUnitIds = async () => {
    const selectedIds = designations.map((d, i) => (checkedItems[i] ? d.id : null)).filter(id => id !== null)
    const r = await api.post("delete-multiple-designation", { items: selectedIds })
    if (r.data.success === true) setLoad(!load)
  }
  const removeFilter = () => {
    setSearch({ desingtype:'' })
    setShowFilter(!showFilter)
  }

  return (
    <>
      <div className="dashBody">
        {canDelete(MID) && (
          <button className="delete-button" onClick={() => setconfirm_multiple_alert(true)}>
            <i className="fa fa-trash"></i>
          </button>
        )}
        <button className="filter_rel btn btn-primary" onClick={() => removeFilter()}>
          <i className="fa fa-filter"></i>
          {showFilter && <i className="rel_filter_ban fa fa-ban"></i>}
        </button>
        <div className="font-size-18 mb-0 dashHeader">
          <Row>
            <Col md={6}><h4>Designations</h4></Col>
            <Col md={6} style={{ textAlign: "right" }}>
              {canAdd(MID) && (
                <Link className="dashBtn" to="/add-designation">
                  <i className="fas fa-plus-square"></i> Add New
                </Link>
              )}
            </Col>
          </Row>
        </div>
        <div className="table-responsive">
          <Table className="table mb-0 dairyTbl" id="designations">
            <thead>
              <tr>
                <th><input type="checkbox" checked={parentChecked} onChange={handleParentCheckboxChange} /></th>
                <th>S.No</th>
                <th>Designation</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {showFilter && (
                <tr>
                  <td></td><td></td>
                  <td><input type="text" className="form-control material_unit_type_sub"
                    onChange={e => setSearch({...search, desingtype: e.target.value})}
                    value={search.desingtype} placeholder="Search by typename" /></td>
                  <td><a className="btn btn-block btn-success applyFilter" title="Apply Filter"><i className="fa fa-search"></i> Apply</a></td>
                </tr>
              )}
              {designations.length > 0 ? (
                designations.filter(item =>
                  (item.designation || "").toLowerCase().includes(search.desingtype.toLowerCase())
                ).map((designation, i) => (
                  <tr key={i}>
                    <td><input type="checkbox" checked={checkedItems[i]} onChange={() => handleCheckboxChange(i)} /></td>
                    <td>{i + 1}</td>
                    <td>{designation.designation}</td>
                    <td>
                      {canEdit(MID) && <Link to={"/edit-designation/" + designation.id}><i className="fas fa-edit icons icon-edit"></i></Link>}
                      {canDelete(MID) && <i className="fas fa-trash-alt icons icon-delete"
                        onClick={() => { setDesigId(designation.id); setCell(i + 1); setconfirm_alert(true) }}></i>}
                    </td>
                  </tr>
                ))
              ) : (
                <tr><td colSpan={4}><img className="loaderImg" src={loader} alt="loading" /></td></tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>
      {confirm_alert && (
        <SweetAlert title="Are you sure?" warning showCancel confirmBtnBsStyle="success" cancelBtnBsStyle="danger"
          onConfirm={() => { fetchDelete(); setconfirm_alert(false); setsuccess_dlg(true); setdynamic_title("Deleted"); setdynamic_description("Designation deleted.") }}
          onCancel={() => setconfirm_alert(false)}>You won't be able to revert this!</SweetAlert>
      )}
      {confirm_multiple_alert && (
        <SweetAlert title="Are you sure?" warning showCancel confirmBtnBsStyle="success" cancelBtnBsStyle="danger"
          onConfirm={() => { getSelectedUnitIds(); setconfirm_multiple_alert(false); setsuccess_dlg(true); setdynamic_title("Deleted"); setdynamic_description("Designations deleted.") }}
          onCancel={() => setconfirm_multiple_alert(false)}>You won't be able to revert this!</SweetAlert>
      )}
      {success_dlg && (
        <SweetAlert success title={dynamic_title} onConfirm={() => setsuccess_dlg(false)}>{dynamic_description}</SweetAlert>
      )}
    </>
  )
}

export default Designations
